import environmentConfigAllComponent from './environment_config.all.component';
import './environment_config.all.scss';

let environmentConfigAllModule = angular.module('environmentConfigAll', [])

    .component('environmentConfigAll', environmentConfigAllComponent)

    .name;

export default environmentConfigAllModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/environment_config/all/index.js